import { createStore, compose, combineReducers } from 'redux';
import authReducer from './reducers/authReducer';
import filterReducer from './reducers/filterReducer';
import globalizationReducer from './reducers/globalizationReducer';

const initialState = {};

const rootReducer = combineReducers({
  auth: authReducer,
  globalization: globalizationReducer,
  filter: filterReducer,
});

const composeEnhancers = (process.env.NODE_ENV !== 'production' && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const store = createStore(
  rootReducer,
  initialState,
  composeEnhancers(),
);

export default store;
